import React, { useState } from 'react';
import { Table, Dropdown, Menu, Button, Space, Typography } from 'antd';
import { EyeOutlined, CloseOutlined, DownOutlined } from '@ant-design/icons';
import './AdminSupportProvider.css';

const { Title } = Typography;

const AdminSupportProvider = () => {
  // Sample data for admin support
  const dataSource = [
    { key: '1', name: 'Dave County services', date: '20/05/25', issue: 'User Request Issue', ip: '192.00.22' },
    { key: '2', name: 'Bush County services', date: '18/05/25', issue: 'User Request Issue', ip: '192.00.22' },
    { key: '3', name: 'Bush County services', date: '18/04/25', issue: 'User Request Issue', ip: '192.00.22' },
  ];

  // Define columns
  const columns = [
    { title: 'Name', dataIndex: 'name', key: 'name' },
    { title: 'Date', dataIndex: 'date', key: 'date' },
    { title: 'Issue', dataIndex: 'issue', key: 'issue', render: (issue) => (
      <span className="issue-text">{issue}</span>
    )},
    { title: 'Last IP Address', dataIndex: 'ip', key: 'ip' },
    { 
      title: 'Action', 
      key: 'action', 
      render: (_, record) => (
        <Space size="middle">
          <Dropdown overlay={menu(record)} trigger={['click']}>
            <Button icon={<DownOutlined />} size="small">
              Actions
            </Button>
          </Dropdown>
        </Space>
      ),
    },
  ];

  // Menu for dropdown actions
  const menu = (record) => (
    <Menu>
      <Menu.Item key="1" icon={<EyeOutlined />} onClick={() => handleView(record)}>
        View
      </Menu.Item>
      <Menu.Item key="2" icon={<CloseOutlined />} onClick={() => handleClose(record)}>
        Close
      </Menu.Item>
    </Menu>
  );

  // Placeholder functions for actions
  const handleView = (record) => {
    console.log('View:', record);
  };

  const handleClose = (record) => {
    console.log('Close:', record);
  };

  return (
    <div className="admin-support-provider-container">
      <Title level={3} className="admin-support-provider-title">Admin Support</Title>
      <Table
        dataSource={dataSource}
        columns={columns}
        pagination={{ pageSize: 5 }}
        className="admin-support-provider-table"
      />
    </div>
  );
};

export default AdminSupportProvider;